import * as types from 'constants/ActionTypes';
import { stripUiAddressFlags } from 'features/order/Order.utils';

const initState = {
  mapError: false, loading: false, reportAddresses: [], loadError: false, reportId: null, addressVerificationMapPoint: null,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case types.LOAD_REPORT_DETAILS_PAGE_LOADING: return { ...state, loading: true, mapError: false };
    case types.LOAD_REPORT_DETAILS_PAGE_LOADED: return { ...state, loading: false, mapError: false };
    case types.ADD_REPORT_ADDRESS_SUCCESS: return { ...state, reportAddresses: action.reportAddresses, mapError: false };
    case types.ADD_REPORT_ADDRESS_FAILURE: return { ...state, mapError: true };
    case types.LOADING_ADDRESS_VERIFICATION_PAGE: return { ...state, loading: true };
    case types.LOAD_ADDRESS_VERIFICATION_PAGE_SUCCESS: return {
      ...state,
      reportId: action.reportId,
      reportDetails: action.reportDetails,
      addressVerificationMapPoint: action.addressVerificationMapPoint,
      loading: false,
      loadError: false,
    };
    case types.LOAD_ADDRESS_VERIFICATION_PAGE_ERROR: return { ...state, loadError: true, loading: false };
    case types.UPDATE_ADDRESS_VERIFICATION_MAP_POINT: return { ...state, addressVerificationMapPoint: action.mapPoint };
    case types.UPDATE_ADDRESS_VERIFICATION_LAT_LONG: return {
      ...state,
      addressVerificationMapPoint: {
        ...state.addressVerificationMapPoint,
        userMovedThePin: true,
        usedZipFallback: false,
        address: stripUiAddressFlags({
          ...state.addressVerificationMapPoint.address,
          latitude: action.newPinLocation.latitude,
          longitude: action.newPinLocation.longitude,
        }),
      },
    };
    case types.CLEAR_REPORT_DETAILS_DATA: return initState;
    default: return state;
  }
};
